import {
    Button,
    Flex,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import React from 'react'
import {remCalc} from '../../../theme/_utils'
import {AlertIcon} from '../../../components/icons'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import Link from '@salesforce/retail-react-app/app/components/link'

const ProductRegistrationModal = ({isOpen, onClose, productName, onRegisterAnyway}) => {
    if (!isOpen) return null

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered blockScrollOnMount={false}>
            <ModalOverlay />
            <ModalContent width={{lg: remCalc(451)}} minWidth={remCalc(343)}>
                <ModalHeader
                    paddingX={remCalc(26)}
                    paddingTop={remCalc(26)}
                    paddingBottom={remCalc(24)}
                >
                    <Flex justifyContent="space-between">
                        <Flex gap={remCalc(17)} alignItems="center">
                            <AlertIcon boxSize="iconsSize.medium" />
                            <Text fontWeight="400" textStyle="body-small" color="text.default">
                                <FormattedMessage
                                    id="product_registration_modal.already_registered_title"
                                    defaultMessage="Product already registered"
                                />
                            </Text>
                        </Flex>
                    </Flex>
                </ModalHeader>
                <ModalBody data-testid="modal-body" paddingX={remCalc(26)} paddingY={0}>
                    <Text fontWeight="400" textStyle="body-small" color="text.default">
                        <FormattedMessage
                            id="product_registration_modal.already_registered"
                            defaultMessage="There is already a registration for {productName} associated with this email address. If you inserted the wrong details, please edit or delete your old product registration before registering it again. If you want to register a different product, please start again."
                            values={{
                                productName,
                            }}
                        />
                    </Text>
                </ModalBody>
                <ModalFooter
                    paddingX={remCalc(26)}
                    paddingTop={remCalc(26)}
                    paddingBottom={remCalc(24)}
                >
                    <Flex flexDir={'column'} gap={remCalc(24)} w={'100%'}>
                        <Button
                            as={Link}
                            variant="primary"
                            onClick={onClose}
                            width="100%"
                            to="/account/registered-products"
                        >
                            <FormattedMessage
                                id="product_registration_modal.registration_details"
                                defaultMessage="Review and edit my registered products"
                            />
                        </Button>
                        <Button
                            onClick={onRegisterAnyway}
                            variant="link"
                            textDecoration={'underline'}
                            color="button.text.text-default"
                            width="100%"
                        >
                            <FormattedMessage
                                defaultMessage="I purchased the same appliance more than once"
                                id="product_registration_modal.register_another_product"
                            />
                        </Button>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

ProductRegistrationModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    productName: PropTypes.string,
    onRegisterAnyway: PropTypes.func,
}

export default ProductRegistrationModal
